import { request } from "./http";

export interface Strategy {
  id: string;
  name: string;
  robot_class: string | null;
  config: Record<string, unknown>;
  status: "inactive" | "running" | "paused" | "stopped";
  account_id: string | null;
  last_checkpoint_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface StrategyCreate {
  name: string;
  robot_class?: string | null;
  config?: Record<string, unknown>;
  account_id?: string | null;
}

export const strategies = {
  list: () => request<Strategy[]>("/piggy/api/strategies"),
  get: (id: string) => request<Strategy>(`/piggy/api/strategies/${id}`),
  create: (body: StrategyCreate) => request<Strategy>("/piggy/api/strategies", { body }),
  delete: (id: string) => request<void>(`/piggy/api/strategies/${id}`, { method: "DELETE" }),
  start: (id: string) => request<Strategy>(`/piggy/api/strategies/${id}/start`, { method: "POST" }),
  stop: (id: string) => request<Strategy>(`/piggy/api/strategies/${id}/stop`, { method: "POST" }),
  pause: (id: string) => request<Strategy>(`/piggy/api/strategies/${id}/pause`, { method: "POST" }),
  resume: (id: string) => request<Strategy>(`/piggy/api/strategies/${id}/resume`, { method: "POST" }),
  classes: () => request<{ strategies: string[] }>("/piggy/api/strategy-classes"),
  schema: (name: string) =>
    request<Record<string, unknown>>(`/piggy/api/strategy-classes/${encodeURIComponent(name)}`),
};
